import React, { useState } from 'react'
import { Form, Icon, Input, Modal, Row, Select, Upload, Col, Button } from 'antd'
import axios from 'axios'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import _, { isNull } from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'

const PresetForm = (props) => {
  const { visible, onOk, onCancel, formData, form, presetCategory } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  const [presetImageUrl, setPresetImageUrl] = useState("")

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        category: formData.presetCategory.id,
        position: formData.position
      })
      setPresetImageUrl(formData.cover.url)
    }
    return () => {
      form.resetFields()
      setPresetImageUrl('')
    }
  }, [formData])

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )
  async function handleChange(info) {
    await getBase64(info.file, (presetImageUrl) => {
      setPresetImageUrl(presetImageUrl)
    })
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          presetCategoryId: values.category,
          position: values.position
        }
        if (values.presetImage) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.presetImage.file)) {
              formImgData.append('image', await compressFile(values.presetImage.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/preset/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.imgId = res.data.id
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          data.imgId = formData.cover.id
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
        setPresetImageUrl('')
      }
    })
  }

  return (
    <Modal
      visible={visible}
      title={`${!_.isEmpty(formData) ? 'Edit ' : 'Create a new '} Preset`}
      footer={null}
      onCancel={onCancel}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item label="ชื่อ">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="ชื่อ" />)}
        </Form.Item>
        <Form.Item label="รูปร่าง">
          {getFieldDecorator(`category`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกรูปร่าง"
              name="presetCategory"
              allowClear
            >
              {presetCategory && presetCategory.map(presetCategory => (
                <Select.Option key={presetCategory.name} value={presetCategory.id}>
                  {presetCategory.name}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>
        <Form.Item label="ลำดับ">
          {getFieldDecorator(`position`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            type="number"
            name="position"
            placeholder="ลำดับ" />)}
        </Form.Item>
        <Form.Item label="รูปหน้าปก">
          <Row type="flex" justify="center">
            <Col>
              {getFieldDecorator(`presetImage`, {
                rules: [
                  {
                    required: isNull(formData),
                    message: 'เลือกรูปภาพ'
                  }
                ]
              })(
                <Upload
                  name="img"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file)}
                  onChange={handleChange}
                >
                  {presetImageUrl ? (
                    <img src={presetImageUrl} alt="img" style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              )}
            </Col>
          </Row>
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              {`${!_.isEmpty(formData) ? 'Save ' : 'Create'}`}
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedPresetForm = Form.create({
  name: 'PresetForm'
})(PresetForm)
export default (WrappedPresetForm)
